import CitiesSelectfield from './cities_selectfield';
import Container from './Container'
import Detail from './Detail'

export default {
  CitiesSelectfield,
  Container,
  Detail
};
